const fullRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',
  'activity-session:approve',

  '/funder:visit',
  '/funder/manage:visit',
  '/funder/my-profile:visit',
  '/funder/insights:visit',

  '/funder/reports:visit',
  '/funder/reports/requirements:visit',
  // '/funder/reports/create:visit',
  '/funder/reports/create-link:visit',
  '/funder/reports/create-report:visit',
  '/funder/reports/:reportId:visit',

  '/funder/reports/templates:visit',
  '/funder/reports/create-template:visit',
  '/funder/reports/templates/:templateId:visit',

  '/funder/exports:visit',
  '/funder/exports/:workspaceId/questions:visit',
  '/funder/exports/:workspaceId/questions/:type/:typeId:visit',
  '/funder/exports/profile-data:visit',
  '/funder/exports/programme-stats:visit',
  '/funder/exports/school-data:visit',

  '/funder/manage:visit',

  '/funder/manage/insights:visit',
  '/funder/manage/insights/create-new:visit',
  '/funder/manage/insights/:insightId:visit',
  '/funder/manage/insights/:insightId/users:visit',
  '/funder/manage/institutions:visit',
  '/funder/manage/institutions/sites:visit',
  '/funder/manage/institutions/sites/hierarchies:visit',
  '/funder/manage/institutions/sites/hierarchies/:hierarchyId:visit',
  '/funder/manage/institutions/sites/hierarchies/create:visit',
  '/funder/manage/institutions/sites/services:visit',
  '/funder/manage/institutions/sites/services/:serviceId:visit',
  '/funder/manage/institutions/sites/services/create:visit',
  '/funder/manage/institutions/create:visit',
  '/funder/manage/institutions/:institutionId:visit',
  '/funder/manage/institutions/cohorts:visit',
  '/funder/manage/institutions/cohorts/create:visit',
  '/funder/manage/institutions/cohorts/:cohortId:visit',
  '/funder/manage/institutions/registrations:visit',
  '/funder/manage/institutions/registrations/archived:visit',
  '/funder/manage/institutions/registrations/create:visit',
  '/funder/manage/institutions/registrations/:institutionId:visit',
  '/funder/manage/institutions/registrations/:institutionId/service-details:visit',
  '/funder/manage/institutions/registrations/:institutionId/service-contacts:visit',
  '/funder/manage/institutions/registrations/:institutionId/registration-management:visit',
  '/funder/manage/institutions/registrations/:institutionId/registrations:visit',
  '/funder/manage/institutions/registrations/:institutionId/registrations/register:visit',
  '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/application:visit',
  '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/framework:visit',
  '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/assessment:visit',
  '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/complete:visit',
  '/funder/manage/institutions/registrations/:institutionId/registrations/:ecdRegistrationId/approve:visit',
  '/funder/manage/people:visit',
  '/funder/manage/people/create:visit',
  '/funder/manage/people/:personId:visit',
  '/funder/manage/people/addnew:visit',
  '/funder/manage/people/cohorts:visit',
  '/funder/manage/people/cohorts/create:visit',
  '/funder/manage/people/cohorts/:cohortId:visit',

  `/funder/team-members:visit`,
  `/funder/team-members/create-new:visit`,
  `/funder/team-members/:teamMemberId:visit`,

  '/funder/programmes/portfolios:visit',
  '/funder/programmes/:programmeId/sites:visit',
  '/funder/programmes/:programmeId/sites/hierarchies:visit',
  '/funder/programmes/:programmeId/sites/hierarchies/:hierarchyId:visit',
  '/funder/programmes/:programmeId/sites/hierarchies/create:visit',
  '/funder/programmes/:programmeId/sites/services:visit',
  '/funder/programmes/:programmeId/sites/services/:serviceId:visit',
  '/funder/programmes/:programmeId/sites/services/create:visit',
  '/funder/programmes/:programmeId/reporters:visit',
  '/funder/programmes/:programmeId/reporters/:reporterId/assignees:visit',
  '/funder/programmes:visit',
  '/funder/programmes/create:visit',
  '/funder/programmes/:programmeId/overview:visit',
  '/funder/programmes/:programmeId/indicators:visit',
  '/funder/programmes/:programmeId/monitoring:visit',
  '/funder/programmes/:programmeId/complete:visit',
  '/funder/programmes/interventions:visit',
  '/funder/programmes/interventions/create:visit',
  '/funder/programmes/interventions/:interventionId/stakeholders:visit',
  '/funder/programmes/interventions/:interventionId/stakeholders/cohorts:visit',
  '/funder/programmes/interventions/:interventionId/stakeholders/cohorts/create:visit',
  '/funder/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId:visit',
  '/funder/programmes/interventions/:interventionId/institutions:visit',
  '/funder/programmes/interventions/:interventionId/institutions/cohorts:visit',
  '/funder/programmes/interventions/:interventionId/institutions/cohorts/create:visit',
  '/funder/programmes/interventions/:interventionId/institutions/cohorts/:cohortId:visit',
  '/funder/programmes/interventions/:interventionId/overview:visit',
  '/funder/programmes/interventions/:interventionId/indicators:visit',
  '/funder/programmes/interventions/:interventionId/inputs:visit',
  '/funder/programmes/interventions/:interventionId/activities:visit',
  '/funder/programmes/interventions/:interventionId/monitoring:visit',
  '/funder/programmes/interventions/:interventionId/complete:visit',
  '/funder/programmes/interventions/:interventionId/reporters:visit',
  '/funder/programmes/interventions/:interventionId/reporters/:reporterId/assignees:visit',

  '/funder/my-activities:visit',
  '/funder/my-activities/:activityId/sessions/:visit',
  '/funder/my-activities/:activityId/sessions/create:visit',
  '/funder/my-activities/:activityId/sessions/:sessionId:visit',
  '/funder/my-activities/:activityId/attendees/:visit',
  '/funder/activities/activity/:activityId:visit',
  '/funder/activities/:stakeholderId:edit',

  '/funder/manage/cases:visit',
  '/funder/manage/cases/:caseId:visit',
  '/funder/manage/cases/consultations:visit',
  '/funder/manage/cases/consultations/:consultationId:visit',
  '/funder/manage/cases/case-management:visit',
  '/funder/manage/cases/case-management/activities/:activityId/configure:visit',
  '/funder/manage/cases/case-management/case-id-configuration:visit',
  '/funder/manage/cases/case-management/case-details-configuration:visit',
  '/funder/manage/cases/case-management/case-summary-configuration:visit',
  '/funder/manage/cases/appointments:visit',
  '/funder/manage/cases/medication-queue:visit',

  '/funder/my-forms:visit',
  '/funder/my-forms/:id/:date/capture:visit',
  '/funder/my-forms/:id/submissions:visit',
  '/funder/my-forms/:id/submissions/:submissionId:visit',
  '/funder/my-forms/:id/submissions/:submissionId/calculate:visit',
  '/funder/my-forms/:id/submissions/calculate/:monitoringFormId/:periodNumber:visit',

  '/funder/my-forms/:id/submissions/submit:visit',

  '/funder/notifications:visit',

  '/funder/manage/admin:visit',
  '/funder/manage/admin/create-new:visit',
  '/funder/admin/workspaces:visit',
  '/funder/admin/workspaces/create-new:visit',
  '/funder/admin/workspaces/:workspaceId:visit',
  '/funder/admin/workspaces/:workspaceId/overview:visit',
  '/funder/admin/workspaces/:workspaceId/overview/datasets/create-new:visit',
  '/funder/admin/workspaces/:workspaceId/overview/datasets/:datasetId:visit',
  '/funder/admin/workspaces/:workspaceId/overview/forms/create-new:visit',
  '/funder/admin/workspaces/:workspaceId/overview/forms/:formId:visit',
  '/funder/admin/templates:visit',

  '/funder/manage/workspaces:visit',
  '/funder/manage/workspaces/create-new:visit',
  '/funder/manage/workspaces/:workspaceId:visit',
  '/funder/manage/workspaces/:workspaceId/overview:visit',
  '/funder/manage/workspaces/:workspaceId/overview/datasets/create-new:visit',
  '/funder/manage/workspaces/:workspaceId/overview/datasets/:datasetId:visit',
  '/funder/manage/workspaces/:workspaceId/overview/forms/create-new:visit',
  '/funder/manage/workspaces/:workspaceId/overview/forms/:formId:visit',

  '/funder/admin/audittrail:visit',
  '/funder/admin/modules:visit',

  '/funder/admin/organisations:visit',
  '/funder/admin/organisations/:organisationId/users:visit',

  '/funder/manage/activities:visit',
  '/funder/manage/activities/:activityId/sessions/:visit',
  '/funder/manage/activities/:activityId/sessions/create:visit',
  '/funder/manage/activities/:activityId/sessions/:sessionId:visit',
  '/funder/manage/activities/:activityId/attendees/:visit',
  '/funder/manage/activities/create:visit',
  '/funder/manage/activities/:activityId:visit',
  '/funder/manage/activities/activity/:activityId:visit',
  '/funder/manage/activities/:stakeholderId:edit',
  '/funder/manage/activities/:activityId/assign-users:visit',
  '/funder/manage/groups:visit',
  '/funder/manage/groups/:groupId/options:visit',
  '/funder/manage/services:visit',
  '/funder/manage/services/:serviceId:visit',
  '/funder/manage/services/create:visit',

  '/funder/manage/indicatorFrameworks:visit',
  '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators:visit',
  '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId:visit',
  '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/indicators/:indicatorId/periods:visit',
  '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/monitoring:visit',
  '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/reporters:visit',
  '/funder/manage/indicatorFrameworks/:indicatorFrameworkId/reporters/:reporterId/assignees:visit',

  '/funder/manage/indicatorFrameworks/period-groups:visit',
  '/funder/manage/indicatorFrameworks/period-groups/:periodGroupId/periods:visit',

  '/funder/interventions/period-groups:visit',
  '/funder/programmes/period-groups/:periodGroupId/periods:visit',
  '/funder/interventions/period-groups/:periodGroupId/periods:visit',
  '/funder/programmes/period-groups:visit',

  '/funder/manage/indicatorFrameworks/currency-groups:visit',
  '/funder/manage/indicatorFrameworks/currency-groups/:currencyGroupId/periods:visit',
  '/funder/interventions/currency-groups/:currencyGroupId/periods:visit',
  '/funder/programmes/currency-groups/:currencyGroupId/periods:visit',
  '/funder/interventions/currency-groups:visit',
  '/funder/programmes/currency-groups:visit',

  '/funder/team-members/:stakeholderId/activities:visit',
  '/funder/team-members/:stakeholderId/activities/:activityId/sessions:visit',
  '/funder/team-members/:stakeholderId/activities/:activityId/sessions/:sessionId:visit',
  '/funder/team-members/:stakeholderId/activities/:activityId/sessions/create:visit',
  '/funder/team-members/:stakeholderId/activities/:activityId/attendees:visit',

  // IB-1897: the plan and the user's Grants access level are checked on the page and on the server
  '/funder/manage/grants:visit',
];

const freeViewerRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/funder:visit',
  '/funder/my-profile:visit',
  '/funder/insights:visit',

  `/funder/team-members:visit`,
  `/funder/team-members/create-new:visit`,
  `/funder/team-members/:teamMemberId:visit`,

  '/funder/notifications:visit',
];

const freeExplorerRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/funder:visit',
  '/funder/manage:visit',
  '/funder/my-profile:visit',
  '/funder/insights:visit',

  '/funder/reports:visit',
  '/funder/reports/requirements:visit',
  // '/funder/reports/create:visit',
  '/funder/reports/create-link:visit',
  '/funder/reports/create-report:visit',
  '/funder/reports/create-template:visit',
  '/funder/reports/:reportId:visit',

  '/funder/exports:visit',
  '/funder/exports/:workspaceId/questions:visit',
  '/funder/exports/:workspaceId/questions/:type/:typeId:visit',
  '/funder/exports/profile-data:visit',
  '/funder/exports/programme-stats:visit',
  '/funder/exports/school-data:visit',

  '/funder/manage:visit',

  '/funder/manage/insights:visit',
  '/funder/manage/insights/create-new:visit',
  '/funder/manage/insights/:insightId:visit',
  '/funder/manage/insights/:insightId/users:visit',
  '/funder/manage/institutions:visit',
  '/funder/manage/institutions/sites:visit',
  '/funder/manage/institutions/sites/hierarchies:visit',
  '/funder/manage/institutions/sites/hierarchies/:hierarchyId:visit',
  '/funder/manage/institutions/sites/hierarchies/create:visit',
  '/funder/manage/institutions/sites/services:visit',
  '/funder/manage/institutions/sites/services/:serviceId:visit',
  '/funder/manage/institutions/sites/services/create:visit',
  '/funder/manage/institutions/create:visit',
  '/funder/manage/institutions/:institutionId:visit',
  '/funder/manage/institutions/cohorts:visit',
  '/funder/manage/institutions/cohorts/create:visit',
  '/funder/manage/institutions/cohorts/:cohortId:visit',
  '/funder/manage/people:visit',
  '/funder/manage/people/create:visit',
  '/funder/manage/people/addnew:visit',
  '/funder/manage/people/:personId:visit',
  '/funder/manage/people/cohorts:visit',
  '/funder/manage/people/cohorts/create:visit',
  '/funder/manage/people/cohorts/:cohortId:visit',

  '/funder/manage/cases:visit',
  '/funder/manage/cases/:caseId:visit',
  '/funder/manage/cases/consultations:visit',
  '/funder/manage/cases/consultations/:consultationId:visit',
  '/funder/manage/cases/case-management:visit',
  '/funder/manage/cases/case-management/activities/:activityId/configure:visit',
  '/funder/manage/cases/case-management/case-id-configuration:visit',
  '/funder/manage/cases/case-management/case-details-configuration:visit',
  '/funder/manage/cases/case-management/case-summary-configuration:visit',
  '/funder/manage/cases/appointments:visit',
  '/funder/manage/cases/medication-queue:visit',

  '/funder/programmes/portfolios:visit',
  '/funder/programmes/:programmeId/sites:visit',
  '/funder/programmes/:programmeId/sites/hierarchies:visit',
  '/funder/programmes/:programmeId/sites/hierarchies/:hierarchyId:visit',
  '/funder/programmes/:programmeId/sites/hierarchies/create:visit',
  '/funder/programmes/:programmeId/sites/services:visit',
  '/funder/programmes/:programmeId/sites/services/:serviceId:visit',
  '/funder/programmes/:programmeId/sites/services/create:visit',
  '/funder/programmes/:programmeId/reporters:visit',
  '/funder/programmes/:programmeId/reporters/:reporterId/assignees:visit',
  '/funder/programmes:visit',
  '/funder/programmes/create:visit',
  '/funder/programmes/:programmeId/overview:visit',
  '/funder/programmes/:programmeId/indicators:visit',
  '/funder/programmes/:programmeId/monitoring:visit',
  '/funder/programmes/:programmeId/complete:visit',
  '/funder/programmes/interventions:visit',
  '/funder/programmes/interventions/create:visit',
  '/funder/programmes/interventions/:interventionId/stakeholders:visit',
  '/funder/programmes/interventions/:interventionId/stakeholders/cohorts:visit',
  '/funder/programmes/interventions/:interventionId/stakeholders/cohorts/create:visit',
  '/funder/programmes/interventions/:interventionId/stakeholders/cohorts/:cohortId:visit',
  '/funder/programmes/interventions/:interventionId/institutions:visit',
  '/funder/programmes/interventions/:interventionId/institutions/cohorts:visit',
  '/funder/programmes/interventions/:interventionId/institutions/cohorts/create:visit',
  '/funder/programmes/interventions/:interventionId/institutions/cohorts/:cohortId:visit',
  '/funder/programmes/interventions/:interventionId/overview:visit',
  '/funder/programmes/interventions/:interventionId/indicators:visit',
  '/funder/programmes/interventions/:interventionId/inputs:visit',
  '/funder/programmes/interventions/:interventionId/activities:visit',
  '/funder/programmes/interventions/:interventionId/monitoring:visit',
  '/funder/programmes/interventions/:interventionId/complete:visit',
  '/funder/programmes/interventions/:interventionId/reporters:visit',
  '/funder/programmes/interventions/:interventionId/reporters/:reporterId/assignees:visit',

  `/funder/team-members:visit`,
  `/funder/team-members/create-new:visit`,
  `/funder/team-members/:teamMemberId:visit`,

  '/funder/notifications:visit',

  '/funder/manage/admin:visit',
  '/funder/manage/admin/create-new:visit',
  '/funder/manage/admin/:workspaceId:visit',
];

const fullGuestRoutes: string[] = [
  '/:visit',
  '/admin/sign-in:visit',
  '/funder/sign-in:visit',
  '/institution/sign-in:visit',
  '/service-provider/sign-in:visit',
  '/forgot-password:visit',

  '/funder:visit',
  '/funder/my-profile:visit',
  '/funder/insights:visit',

  '/funder/reports:visit',
  '/funder/reports/requirements:visit',
  // '/funder/reports/create:visit',
  '/funder/reports/create-link:visit',
  '/funder/reports/create-report:visit',
  '/funder/reports/create-template:visit',
  '/funder/reports/:reportId:visit',

  '/funder/notifications:visit',

  // IB-1897: guests see Grants only if Grants settings gives them a level
  '/funder/manage/grants:visit',
];

export const FUNDER_OWNER_PLANS = {
  FREE_VIEWER: {
    static: [
      ...freeViewerRoutes,
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  FREE_EXPLORER: {
    static: [
      ...freeExplorerRoutes,
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  STANDARD: {
    static: [
      ...fullRoutes,
      '/funder/manage/templates:visit',
      '/funder/manage/templates/create-new:visit',
      '/funder/manage/templates/:templateId:visit',
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/funder/manage/dashboards/metabase:visit',
      '/funder/manage/dashboards/metabase/:type/:id:visit',
    ],
  },
  PREMIUM: {
    static: [
      ...fullRoutes,
      '/funder/manage/templates:visit',
      '/funder/manage/templates/create-new:visit',
      '/funder/manage/templates/:templateId:visit',
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/funder/manage/dashboards/metabase:visit',
      '/funder/manage/dashboards/metabase/:type/:id:visit',
    ],
  },
  ENTERPRISE: {
    static: [
      ...fullRoutes,
      '/funder/manage/templates:visit',
      '/funder/manage/templates/create-new:visit',
      '/funder/manage/templates/:templateId:visit',
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/funder/manage/dashboards/metabase:visit',
      '/funder/manage/dashboards/metabase/:type/:id:visit',
    ],
  },
  BUSINESS: {
    static: [
      ...fullRoutes,
      '/funder/manage/templates:visit',
      '/funder/manage/templates/create-new:visit',
      '/funder/manage/templates/:templateId:visit',
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/funder/manage/dashboards/metabase:visit',
      '/funder/manage/dashboards/metabase/:type/:id:visit',
    ],
  },
};

export const FUNDER_ADMIN_PLANS = {
  FREE_VIEWER: {
    static: [
      ...freeViewerRoutes,
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  FREE_EXPLORER: {
    static: [
      ...freeExplorerRoutes,
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
    ],
  },
  STANDARD: {
    static: [
      ...fullRoutes,
      '/funder/manage/templates:visit',
      '/funder/manage/templates/create-new:visit',
      '/funder/manage/templates/:templateId:visit',
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/funder/manage/dashboards/metabase:visit',
      '/funder/manage/dashboards/metabase/:type/:id:visit',
    ],
  },
  PREMIUM: {
    static: [
      ...fullRoutes,
      '/funder/manage/templates:visit',
      '/funder/manage/templates/create-new:visit',
      '/funder/manage/templates/:templateId:visit',
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/funder/manage/dashboards/metabase:visit',
      '/funder/manage/dashboards/metabase/:type/:id:visit',
    ],
  },
  ENTERPRISE: {
    static: [
      ...fullRoutes,
      '/funder/manage/templates:visit',
      '/funder/manage/templates/create-new:visit',
      '/funder/manage/templates/:templateId:visit',
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/funder/manage/dashboards/metabase:visit',
      '/funder/manage/dashboards/metabase/:type/:id:visit',
    ],
  },
  BUSINESS: {
    static: [
      ...fullRoutes,
      '/funder/manage/templates:visit',
      '/funder/manage/templates/create-new:visit',
      '/funder/manage/templates/:templateId:visit',
      '/funder/admin:visit',
      '/funder/manage/reporting-requirements:visit',
      '/funder/manage/reporting-requirements/:requirementId:visit',
      '/funder/account:visit',
      '/funder/manage/dashboards:visit',
      '/funder/manage/dashboards/layout/create-new:visit',
      '/funder/manage/dashboards/layout/:layoutId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId:visit',
      '/funder/manage/dashboards/workspace/:workspaceId/:dashboardId/users:visit',
      '/funder/manage/dashboards/metabase:visit',
      '/funder/manage/dashboards/metabase/:type/:id:visit',
    ],
  },
};

export const FUNDER_MEMBER_PLANS = {
  FREE_VIEWER: {
    static: freeViewerRoutes,
  },
  FREE_EXPLORER: {
    static: freeExplorerRoutes,
  },
  STANDARD: {
    static: fullRoutes,
  },
  PREMIUM: {
    static: fullRoutes,
  },
  ENTERPRISE: {
    static: fullRoutes,
  },
  BUSINESS: {
    static: fullRoutes,
  },
};

export const FUNDER_GUEST_PLANS = {
  FREE_VIEWER: {
    static: [
      '/:visit',
      '/admin/sign-in:visit',
      '/funder/sign-in:visit',
      '/institution/sign-in:visit',
      '/service-provider/sign-in:visit',
      '/forgot-password:visit',

      '/funder:visit',
      '/funder/my-profile:visit',
      '/funder/insights:visit',
    ],
  },
  FREE_EXPLORER: {
    static: fullGuestRoutes,
  },
  STANDARD: {
    static: fullGuestRoutes,
  },
  PREMIUM: {
    static: fullGuestRoutes,
  },
  ENTERPRISE: {
    static: fullGuestRoutes,
  },
  BUSINESS: {
    static: fullGuestRoutes,
  },
};
